<template>
  <div class="p-1">
    <p v-for="(item, index) in params.value" :key="index">
      {{ item }}
    </p>
    <br />
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("params aaray", this.params.value);
  },
  methods: {},
};
</script>
